// src/utils/addons.js — safe add-on names (an add-on with no "name" must never become "undefined")
export function optionLabel(opt) {
  if (!opt) return 'Add-on';
  const direct = opt.name ?? opt.label ?? opt.title ?? opt.optionName;
  if (direct !== undefined && direct !== null && String(direct).trim()) return String(direct).trim();
  // Fall back to the id the admin panel generates, e.g. "extra_cheese_1712345678901" -> "Extra Cheese"
  const fromId = String(opt.id || '').replace(/_\d{10,}$/, '').replace(/[_-]+/g, ' ').trim();
  return fromId ? fromId.replace(/\b\w/g, (c) => c.toUpperCase()) : 'Add-on';
}

// Always a clean array of non-empty strings (accepts strings or {name} objects)
export const cleanAddons = (arr) =>
  (Array.isArray(arr) ? arr : [])
    .map((a) => (typeof a === 'string' ? a : a && (a.name || a.label)))
    .filter((a) => typeof a === 'string' && a.trim())
    .map((a) => a.trim());